var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-group date date-picker",
      staticStyle: { width: "200px" }
    },
    [
      _c("span", { staticClass: "input-group-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn blue",
            attrs: { type: "button", tabindex: "-1", disabled: _vm.disabled },
            on: { click: _vm.previousDay }
          },
          [_c("i", { staticClass: "fa fa-arrow-left" })]
        )
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "date-picker",
        staticClass:
          "no-focus form-control form-control-inline input_placeholder",
        attrs: {
          name: _vm.name,
          type: "text",
          placeholder: _vm.placeholder,
          disabled: _vm.disabled
        },
        domProps: { value: _vm.defaultDate },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "input-group-btn" }, [
        _c(
          "button",
          {
            staticClass: "btn blue",
            attrs: { type: "button", tabindex: "-1", disabled: _vm.disabled },
            on: { click: _vm.nextDay }
          },
          [_c("i", { staticClass: "fa fa-arrow-right" })]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }